import FullTextSearch from './FullTextSearch';
export default FullTextSearch;



// WEBPACK FOOTER //
// ./src/components/App/RouteTaskDashboard/SubHeader/FullTextSearch/index.js